import { setItemStorage, getItemStorage, removeItemStorage } from "@/core/helpers/storage";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import store from "@/store";

class AuthService {
    /**
     * get user detail
     * @returns object
     */
    public static getUserDetail(): any {
        const userDetail: any = store.getters.getUserDetail; // || getItemStorage("usr");
        return userDetail;
    }

    /**
     * get user features
     * @returns object
     */
    public static getUserFeatures(): any {
        const user_features: any = store.getters.getUserFeatures;
        return user_features;
    }

    /**
     * get user properties list
     * @returns array
     */
    public static getUserPropertiesList(): any {
        const user_properties: any = store.getters.getUserPropertiesList;
        return user_properties;
    }

    /**
     * get selected user property value
     * @returns string
     */
    public static getUserProperty(): any {
        const userProperty: any = store.getters.getUserProperty; // || getItemStorage("usr_prop");
        return userProperty;
    }

    /**
     * Is Dynamic Pricing switched on for the selected property (System setup > Hotels)?
     * Older sessions without the flag count as on, so nothing disappears until the next login refresh.
     */
    public static isDynamicPricingEnabled(): boolean {
        const current = this.getUserProperty();
        const list: any[] = this.getUserPropertiesList() || [];
        const row = list.find((p: any) => p?.id === current);
        return row?.dynamic_pricing_enabled !== false;
    }

    /**
     * set selected user propperty value
     */
    public static setUserProperty(value: any): void {
        store.commit(Mutations.SET_USER_PROPERTY, value);
        // setItemStorage('usr_prop', value);
    }

    /**
     * check if user can access the feature
     * @returns boolean
     */
    public static isUserFeature(feature_name: any, meta_name: any = ""): boolean {
        let is_feature = false;
        const user_features = store.getters.getUserFeatures;
        const have_feature_name = user_features ? user_features[feature_name] : null;
        if (have_feature_name) {
            if (meta_name) {
                const have_feature_meta = have_feature_name.includes(meta_name);
                is_feature = have_feature_meta;
            } else {
                is_feature = !!have_feature_name;
            }
        }

        return is_feature;
    }

    /**
     * Booking folio actions: Reservation List first, Booking Editor as fallback
     * until the Bookings menu is removed.
     */
    public static isBookingAction(meta_name: string): boolean {
        return this.isUserFeature('reservation_list', meta_name)
            || this.isUserFeature('booking_editor', meta_name);
    }
}

export default AuthService;